// ⚠️ `import type`: модуль читает сайдбар кабинета, и значение из общего пакета
// здесь не нужно вовсе.
import type { Subject } from "@edu/shared";

/**
 * Предметы, у которых есть карта тем, в порядке переключателя на экране.
 *
 * Отдельным модулем, а не константой экрана: его читает сайдбар, чтобы решить,
 * показывать ли пункт «Карта тем», и тащить ради этого в стартовый чанк экран
 * с тремя картами нельзя.
 */
export const COVERAGE_SUBJECTS = ["math", "english", "russian"] as const satisfies readonly Subject[];
export type CoverageSubject = (typeof COVERAGE_SUBJECTS)[number];

/**
 * Карты по предметам преподавателя. Список приезжает уже разрешённым
 * (`useTeacherSubjects`). Пустой ответ законен (преподаватель одного
 * немецкого): тогда пункта в сайдбаре нет.
 */
export function coverageSubjectsOf(teacher: readonly Subject[]): CoverageSubject[] {
  return COVERAGE_SUBJECTS.filter((s) => teacher.includes(s));
}

/**
 * Какую карту открыть: ту, что в адресе, если она среди доступных; иначе
 * первую из доступных. Адрес приходит извне (карту присылают ссылкой) и может
 * называть предмет, которого у этого преподавателя нет: тогда первая своя, а
 * не пустой экран.
 */
export function coveragePick(
  asked: string | null,
  available: readonly CoverageSubject[],
): CoverageSubject | null {
  return available.find((s) => s === asked) ?? available[0] ?? null;
}
